export function setInputTextElement(
  inputElement: HTMLInputElement,
  value: string,
): HTMLInputElement {
  // Starting in React v16, React overloads the `value` setter, so it no longer
  // works as expected to set the value attribute of an input element directly.
  // https://github.com/facebook/react/issues/11488
  const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
    window.HTMLInputElement.prototype,
    'value',
  ).set
  nativeInputValueSetter.call(inputElement, value)

  // We then dispatch an input event, which triggers the onChange handler setup
  // in React; this makes sure that the component state updates to include our
  // updated values.  Note: dispatchEvent triggers the listener synchronously.
  // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/dispatchEvent
  inputElement.dispatchEvent(new Event('input', { bubbles: true }))
  return inputElement
}

export function setSelectElement(
  selectElement: HTMLSelectElement,
  value: string,
): HTMLSelectElement {
  const nativeSelectValueSetter = Object.getOwnPropertyDescriptor(
    window.HTMLSelectElement.prototype,
    'value',
  ).set
  nativeSelectValueSetter.call(selectElement, value)

  // We then dispatch a change event, which triggers the onChange handler setup
  // in React; this makes sure that the component state updates to include our
  // updated values.
  selectElement.dispatchEvent(new Event('change', { bubbles: true }))
  return selectElement
}
